import { Component } from 'react'
import { Choice, Code, CodeableConcepts, CodeableConcept } from '../helpers'
import { GiMedicalDrip } from 'react-icons/gi'

import './resource.css'

class Procedure extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isJson: false,
            css: false
        }
    }

    handleJson() {
        this.setState({ css: !this.state.css })
        setTimeout(() => this.setState({ isJson: !this.state.isJson }), 300)
    }

    handleSelect(id) {
        if (this.props.onSelect) this.props.onSelect(id)
    }

    render() {
        return <div className={`Flip-Container`} onClick={() => this.handleJson()}><div className={`Res-Container Res-Condition${this.state.css ? ' Flip' : ''}`}>
            {this.state.isJson ? <div className='Res-Json'><pre>{JSON.stringify(this.props.resource, undefined, 2)}</pre></div> :
                <div>
                    <div className='Res-row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.status && 'Status'}</div>
                            <div className='Res-Title'>{this.props.resource.status && Code(this.props.resource.status)}</div>
                        </div>
                        <div className='Res-Icon-Big'><GiMedicalDrip /></div>
                        <div>
                            <div style={{ textAlign: 'right' }} className='Res-Detail Res-Content-Rev'>{this.props.resource.category && 'Classification'}</div>
                            <div className='Res-Title'>{this.props.resource.category && CodeableConcept(this.props.resource.category)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.code && 'Procedure'}</div>
                        <div className='Res-Title'>{this.props.resource.code && CodeableConcept(this.props.resource.code)}</div>
                    </div>
                    <div className='Res-Row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.reasonCode && 'Reason'}</div>
                            <div className='Res-Title'>{this.props.resource.reasonCode && CodeableConcepts(this.props.resource.reasonCode)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.outcome && 'Result'}</div>
                            <div className='Res-Title'>{this.props.resource.outcome && CodeableConcept(this.props.resource.outcome)}</div>
                        </div>
                    </div>
                    <div className='Res-Row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.bodySite && 'Site'}</div>
                            <div className='Res-Title'>{this.props.resource.bodySite && CodeableConcepts(this.props.resource.bodySite)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.focalDevice && 'Device'}</div>
                            <div className='Res-Title'>{this.props.resource.focalDevice && CodeableConcept(this.props.resource.focalDevice)}</div>
                        </div>
                    </div>
                    <div className='Res-Row Res-Flex-Spread'>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.complication && 'Complication'}</div>
                            <div className='Res-Title'>{this.props.resource.complication && CodeableConcepts(this.props.resource.complication)}</div>
                        </div>
                        <div>
                            <div className='Res-Detail Res-Content-Rev'>{this.props.resource.followUp && 'Follow Up'}</div>
                            <div className='Res-Title'>{this.props.resource.followUp && CodeableConcepts(this.props.resource.followUp)}</div>
                        </div>
                    </div>
                    <div className='Res-Row'>
                        <div className='Res-Detail Res-Content-Rev'>{this.props.resource.usedCode && 'Used'}</div>
                        <div className='Res-Title'>{this.props.resource.usedCode && CodeableConcepts(this.props.resource.usedCode)}</div>
                    </div>
                    <div className='Res-row'>
                        <div className='Res-Detail Res-Content-Rev'>{(this.props.resource.performedDateTime || this.props.resource.performedString || this.props.resource.performedPeriod || this.props.resource.performedAge || this.props.resource.performedRange) && 'Performed'}</div>
                        {this.props.resource.performedDateTime && <div className='Res-Detail'>{Choice('DateTime', this.props.resource.performedDateTime)}</div>}
                        {this.props.resource.performedString && <div className='Res-Detail'>{Choice('String', this.props.resource.performedString)}</div>}
                        {this.props.resource.performedPeriod && <div className='Res-Detail'>{Choice('Period', this.props.resource.performedPeriod)}</div>}
                        {this.props.resource.performedAge && <div className='Res-Detail'>{Choice('Age', this.props.resource.performedAge)}</div>}
                        {this.props.resource.performedRange && <div className='Res-Detail'>{Choice('Range', this.props.resource.performedRange)}</div>}
                    </div>
                </div>
            }
        </div></div>
    }
}

export default Procedure